export default __webpack_public_path__ + "static/media/thumbnail.84d13900.png";